import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as NavLogo } from '../../../home-redesign/assets/nav-logo.svg';
import { portalCopy } from '../copy';
import { usePartnerAuth } from '../context/PartnerAuthContext';
import { PortalButton } from './PortalUi';

const PartnerPortalNav: React.FC = () => {
  const { user, logout } = usePartnerAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-[rgba(74,33,71,0.1)] bg-[rgba(252,247,250,0.92)] backdrop-blur-[5px]">
      <nav className="mx-auto flex w-full max-w-[960px] items-center justify-between gap-4 px-5 py-3 sm:px-8">
        <Link
          to="/partners/panel"
          className="shrink-0 text-chisme-primary"
          aria-label={portalCopy.nav.logoAria}
        >
          <NavLogo aria-hidden className="block h-7 w-[89px] max-w-none" />
        </Link>

        {user && (
          <div className="flex items-center gap-3">
            <span className="hidden font-jakarta text-sm text-[#5a3158] sm:inline">{user.email}</span>
            <PortalButton variant="ghost" className="!min-h-[36px] !px-4 !py-2 !text-[13px]" onClick={logout}>
              {portalCopy.nav.logout}
            </PortalButton>
          </div>
        )}
      </nav>
    </header>
  );
};

export default PartnerPortalNav;
